import styled, { css } from 'styled-components'

interface ButtonProps {
  readonly height: number
  readonly width: number
  borderRadius: number
  src: string
}

export const Container = styled.div`
  border-radius: 10px;
  padding: 15px;
  border: 1px solid #d9d9d9;
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
`

export const Title = styled.div`
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: ${({ theme }) => theme.colors.primary};
`
